import React from 'react';
import {Products} from 'api';
import {withRouter} from 'react-router-dom';
import Product from "components/partials/product";

class TopProductList extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      data: [],
      limit: 8,
      order: "id DESC"
    };
  }

  componentDidMount() {
    let params = {
      filter: {
        limit: this.state.limit,
        order: this.state.order,
        where: {
          isTop: true
        }
      }
    };
    Products.actions.list.request(params).then(response => {
      this.setState({data: response.data});
    });
  }

  render() {
    return (
      <div className="wrap-top-product">
        <div className='top-product-list'>
          {this.state.data.map((item, i) => {
            return (<Product {...item} showDescription={false} enableAddProduct={true}/>);
          })}
        </div>
      </div>
    );
  }
}

export default withRouter(TopProductList);



// WEBPACK FOOTER //
// ./components/home/sub-view/TopProduct/TopProductList.jsx